export default {
    reports:"รายงาน",
    inventory: "รายการสินค้า",
    visit: "เยี่ยม",
    service: "บริการ",
    doctor: "แพทย์",
    staff: "พนักงาน"
}